import '../../App.css';
import '../Css/Banner.css';
import NavBar from './Navbar/NavBar';

export default function Banner() {


  return (
    <div className='banner'>
        <div id='logoContainer'>
          <a href='#container' id='logoLink'><img id='logo' src='./Images/Icons/sunflower-icon-2.png'></img></a>
          <a href='#container'><div className='bannerName'>Mariage Bénédicte Rambaud - Sylvain Rey</div></a>
        </div>
        <NavBar />
    </div>
    
  );
}